import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface RequestParams {
  /** 当前页 */
  page: number
  /** 每页数量 */
  limit: number
  /** 结束时间，时间戳(秒) */
  end_time?: string
  /** 事件类型集合 1=系统登录，2=远程登录, 3=二次认证 */
  event_type?: number
  /** 分组id */
  group_id?: string
  /** 关键词搜索 */
  key_word?: string
  /** 日志类型 1-登录成功，2-登出 ,3=登录失败， 4=二次认证成功，5=二次认证失败 */
  log_type?: number
  /** 来源IP */
  source_ip?: string
  /** 开始时间，时间戳(秒) */
  start_time?: string
  date: (string|number)[]
}

export interface AuthLogItem {
  /** id */
  id: string
  /** 团队id */
  team_id: string
  /** 设备id */
  device_id: string
  /** 用户名 */
  name: string
  /** 主机名 */
  domain: string
  /** 日志类型 1-登录，2-登出 */
  log_type: number
  /** 日志时间，时间戳(秒) */
  log_time: string
  /** 创建时间，时间戳(秒) */
  create_time: string
  /** 来源IP */
  source_ip: string
  /** 计算机名 */
  computer_name?: string
  /** 事件类型 */
  event_type?: number
  /** 分组id */
  group_id?: string
  /** 分组名 */
  group_name?: string
  /** 是否管理员 */
  is_admin?: number
  /** 登录协议 */
  login_protocol?: string
  /** 来源IP区域 */
  source_ip_location?: string
  /** 登记用户名 */
  user_mark?: string
}

export interface ResponseData {
  /** 用户登录日志列表 */
  data: AuthLogItem[]
  /** 总数 */
  total: string
}
export interface terminalStatTopRequestParams {
  /** 开始时间（时间戳，单位：秒）；「全部」统计时可不传 */
  start_time?: string
  /** 结束时间（时间戳，单位：秒） */
  end_time?: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

export interface TopTerminalList {
  /** 终端名称（含所属部门） */
  computer_name: string
  /** 所属部门 */
  department: string
  /** 远程登录总次数 */
  login_count: number
  /** 以下字段若接口返回则用于列表带参 */
  device_id?: string
  group_id?: string
}

export interface terminalStatTopResponseData {
  /** 终端远程登录次数TOP列表 */
  top_terminal_list: TopTerminalList[]
}
export interface trendStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 趋势粒度："hour"表示按小时，"day"表示按天（可选，默认"hour"） */
  granularity?: string
}

export interface trendStatResponseData {
  /** 远程登录成功次数趋势列表（与time_points一一对应） */
  login_success_list: number[]
  /** 远程登录失败次数趋势列表（与time_points一一对应） */
  login_fail_list: number[]
  /** 时间戳列表（单位：秒，与登录数据一一对应） */
  time_points: string[]
}
export interface overviewStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
}

export interface overviewStatResponseData {
  /** 今日远程登录总次数（登入成功+登入失败+二次认证成功+二次认证失败） */
  today_total_login_count: number
  /** 今日登录成功次数（登入成功+二次认证成功） */
  today_login_success_count: number
  /** 今日登录失败次数（登入失败+二次认证失败） */
  today_login_fail_count: number
}
@Injectable()
export class RemoteAuthLoginService {
  constructor(private http: Http) { }
  // 日志列表
  @ParamsClean()
  getTerminalUserLoginLogPage(data: RequestParams) {
    data.log_type ||= 0
    return this.http.post<ResponseData>('/terminal/user_login_log/page', data)
  }
  // 导出日志
  getTerminalUserLoginLogExport(type: 0 | 1 = 0, data: Partial<RequestParams>, moduleName: string) {
    const params = Object.assign({}, data, {
      file_type: type,
      log_type:0,
      page: 1, // 不分页
      limit: 9999999
    })
    return this.http.downloadWithBlob('/terminal/user_login_log/export', params, moduleName)
  }
  // 刷新动态口令
  getStrategyRemoteLoginAuthRefreshDynamicPassword(data: { id: string }) {
    return this.http.post<void>('/strategy/remote_login_auth/refresh_dynamic_password', data)
  }
  // 绑定动态口令
  getStrategyRemoteLoginAuthBindDynamicPassword(data: { id: string }) {
    return this.http.post<{ bind_url: string }>('/strategy/remote_login_auth/bind_dynamic_password', data)
  }
  // 
  getTerminalRemoteLoginTopTerminalStat (data: terminalStatTopRequestParams) {
    return this.http.post<terminalStatTopResponseData>('/terminal/remote-login-top-terminal-stat', data)
  }
  getTerminalRemoteLoginTrendStat (data: trendStatRequestParams) {
    return this.http.post<trendStatResponseData>('/terminal/remote-login-trend-stat', data)
  }
  getTerminalRemoteLoginOverviewStat (data: overviewStatRequestParams) {
    return this.http.post<overviewStatResponseData>('/terminal/remote-login-overview-stat', data)
  }
}
